import { render, staticRenderFns } from "./HandleQuestionSidebar.vue?vue&type=template&id=776d1b0a&scoped=true&"
import script from "./HandleQuestionSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleQuestionSidebar.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=776d1b0a&prod&scoped=true&lang=css&"
import style1 from "./HandleQuestionSidebar.vue?vue&type=style&index=1&id=776d1b0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d1b0a",
  null
  
)

export default component.exports